import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { RemoteApiService } from '../core/services/remote-api.service';
import { Profile, ProfileConfig, ProfileModelService, ProfileRole } from './profile-model.service';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class ProfileService {

    constructor(private remoteApi: RemoteApiService, private profileModelService: ProfileModelService) { }

    get(token: string): Observable<Profile> {
        return this.remoteApi.postProfile<Profile>(`/profile/retrieve`, token, new HttpHeaders({
            'Content-Type': 'text/plain'
        }));
    }

    updateUserName(token: string, userName: string): Observable<Profile> {
        return this.remoteApi.putProfile<Profile>(`/profile`, {
            token: token,
            userName: userName
        } as Profile, new HttpHeaders({
            'Content-Type': 'application/json'
        }));
    }

    updateConfiguration(configuration: ProfileConfig): Observable<Profile> {
        return this.remoteApi.putProfile<Profile>(`/profile`, {
            token: this.profileModelService.token,
            configuration: configuration
        } as Profile, new HttpHeaders({
            'Content-Type': 'application/json'
        }));
    }

    updateRole(token: string, role: ProfileRole): Observable<Profile> {
        return this.remoteApi.putProfile<Profile>(`/profile`, {
            token: token,
            role: role
        } as Profile, new HttpHeaders({
            'Content-Type': 'application/json'
        }));
    }

}
